import type { DatePeriod, DateSelectionOption } from '@carrefour-gcs/shared';

/**
 * Granularities the period filter works with, in the order the UI offers them.
 */
export const PERIOD_GRANULARITIES = ['daily', 'weekly', 'monthly'] as const satisfies readonly DatePeriod[];

/**
 * Preset periods the UI offers next to a custom range, in the order they are displayed.
 */
export const PERIOD_PRESET_OPTIONS = [
  'year_to_date',
  'cumulative_to_date',
  'last_period'
] as const satisfies readonly DateSelectionOption[];
